import type { Permission } from "@/libs/types/AppTypes";
import { permissions } from "@/store/permissions";

export function usePermission() {
  const assignedPermissions = permissions.list;
  const hasAccess = (permission: Permission) => assignedPermissions.includes(permission);

  return { hasAccess };
}
